<template>
  <div>
    <marquee width="100%" direction="left" class="marqueeSection">
      <div style="display: flex; align-items: center;height: 30px;">
        Please note that this API documentation link is no longer active. Kindly refer to our updated API documentation available at the new link.
        <a href="https://ant.aliceblueonline.com/productdocumentation/" target="_blank" style="text-decoration: none; color: blue;" >
    https://ant.aliceblueonline.com/productdocumentation/
  </a>
      </div>

</marquee>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  created() {
    // const reloaded = localStorage.getItem("reloaded");
    // if (reloaded !== "true") {
    //   localStorage.setItem("reloaded", "true");
    //   location.reload();
    // }
    var activeTab = localStorage.getItem("activeTab");
    if (activeTab) {
      this.$store.commit("setCurrentActiveTabCodeBlock", activeTab);
    }
  },
  mounted() {
    document.title = this.$store.state.appTitle;
  },
};
</script>

<style>
.v-application--is-ltr .v-treeview-node__content {
  margin-left: 0 !important;
}

/* .v-treeview-node__level {
  width: 14px !important;
} */

.v-treeview-node__prepend {
  min-width: 16px;
}

.v-treeview-node__toggle {
  width: 8px;
}
</style>